/* global route */

import debounce from 'lodash.debounce';
import md5 from 'md5';
import axios from 'axios';

function generateIndexKey(uids) {
  return md5(uids.join(','));
}

function generateUrlFunction(uids, readOnly = false, caseId = null) {
  return async function () {
    try {
      const response = await axios.get(route('get-viewer-url', { studies: uids, read_only: readOnly ? 1 : 0, caseId }));

      return response.data.data.url;
    } catch (err) {
      console.error(err);
    }

    return null;
  };
}

const TIMEOUT = 120000;

class MeddreamRepository {
  #index = {};
  #intervals = {};
  #urls = {};
  #store = null;

  constructor() {
    this.updateStore = debounce(() => {
      if (this.#store) {
        this.#store.commit('updateMeddreamUrls', this.#urls);
      }
    }, 300);
  }

  async studiesUrl(studies = [], readOnly = false, caseId = null) {
    if (studies.length) {
      const uids = studies.map(({ studyInstanceUid }) => studyInstanceUid);
      const indexKey = this.getIndexKey(studies, readOnly);

      if (!this.#index[indexKey]) {
        this.#index[indexKey] = generateUrlFunction(uids, readOnly, caseId);
        this.#urls[indexKey] = await this.#index[indexKey]();
        this.#intervals[indexKey] = setInterval(async () => {
          this.#urls[indexKey] = await this.#index[indexKey]();
          this.updateStore();
        }, TIMEOUT);
        this.updateStore();
      }

      return await this.#urls[indexKey];
    }

    return null;
  }

  registerStore(Store) {
    if (!this.#store) {
      this.#store = Store;
    }

    return this;
  }

  getIndexKey(studies, readOnly = false) {
    let key = generateIndexKey(studies.filter((item) => !!item).map(({ studyInstanceUid }) => studyInstanceUid));

    if (readOnly) {
      key = `ro-${key}`;
    }

    return key;
  }
}

const Repository = new MeddreamRepository();

export default MeddreamRepository;
export { Repository as MeddreamRepository };
export { generateUrlFunction };
